/**
 * Created by Kevin on 2017-08-08.
 */
angular.module('flipto.core.enums')
    .constant('overlayTypes', [
        { id: "0", name: 'BottomBanner', description: 'Along the bottom of the screen' },
        { id: "1", name: 'BottomRightCorner', description: 'Positioned at the bottom right corner' },
        { id: "2", name: 'BottomLeftCorner', description: 'Positioned at the bottom left corner' }
    ]);